import { NgModule }              from '@angular/core';
import { RouterModule, Routes }  from '@angular/router';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { CmsComponent } from './cms/cms.component';
import { ActualiteComponent } from './actualite/_list/actualite.component';
import { ActualiteDetailComponent } from './actualite/_detail/actualite-detail.component';
import { KneServicesComponent } from './kne-services/kne-services.component';
import { NouveauteComponent } from './nouveaute/nouveaute.component';
import { ArticleComponent } from './article/article.component';
//import { ArticleResolver } from './article/article-resolver.service';
import { CartComponent } from './user/_cart/cart.component';

//Not auth
import { SignInComponent } from './user/_sign-in/sign-in.component';
import { LogInComponent } from './user/_log-in/log-in.component';

//Auth
import { ProfileComponent } from './user/_profile/profile.component';
import { PurchasesComponent } from './user/_purchases/purchases.component';
import { ValidationComponent } from './user/_validation/validation.component';
import { AddressComponent } from './user/_address/address.component';
import { RessourcesComponent } from './user/_ressources/ressources.component';
import { PaymentComponent } from './user/_payment/payment.component';
import { ConfirmComponent } from './user/_confirm/confirm.component';

import {
  AuthGuard,
  NotAuth,
  ListComponent,
  FooterComponent,
  HeaderComponent,
} from './shared';

const routes: Routes = [
  {
    path: 'familles',
    children: [
      { path: '', component: HomeComponent },
      // { path: 'services', component: KneServicesComponent },
      { path: 'recherche', component: ListComponent },
      { path: 'recherche/:query', component: ListComponent },
      { path: 'primaire', component: ListComponent },
      { path: 'college', component: ListComponent },
      { path: 'lycee', component: ListComponent },
      { path: 'lycee-pro', component: ListComponent },
      { path: 'post-bac', component: ListComponent },
      { path: 'fle', component: ListComponent },
      { path: 'editeur/:id', component: ListComponent },
      {
        path: 'article/:slug', component: ArticleComponent
      },
      { path: 'actualites', component: ActualiteComponent },
      { path: 'actualite/:slug', component: ActualiteDetailComponent },
      { path: 'nouveautes', component: NouveauteComponent },
      { path: 'mon-panier', component: CartComponent },
      //Not Auth
      { path: 'creer-compte', component: SignInComponent, canActivate: [NotAuth] },
      { path: 'identification', component: LogInComponent, canActivate: [NotAuth] },
      //Auth
      { path: 'mon-compte', component: ProfileComponent, canActivate: [AuthGuard] },
      { path: 'mes-commandes', component: PurchasesComponent },
      { path: 'mes-ressources', component: RessourcesComponent },
      { path: 'justificatifs', component: ValidationComponent },
      { path: 'adresses', component: AddressComponent },
      { path: 'paiement', component: PaymentComponent },
      { path: 'confirmation', component: ConfirmComponent },
      //CMS
      { path: 'comment-ca-marche', component: CmsComponent, data : {slug : 'acheter-une-licence-familles'} },
      { path: 'cgv', component: CmsComponent, data : {slug : 'cgv-familles'} },
      { path: 'cgu', component: CmsComponent, data : {slug : 'cgu-familles'} },
      { path: 'cookies', component: CmsComponent, data : {slug : 'cookies-familles'} },
      { path: 'services', component: CmsComponent, data: {slug: 'services'}},
      { path: 'donnees-personnelles', component: CmsComponent, data : {slug : 'donnees-personnelles-familles'} },
      { path: 'mentions-legales', component: CmsComponent, data : {slug : 'mentions-legales-familles'} },
      { path: 'qui-sommes-nous', component: CmsComponent, data : {slug : 'qui-sommes-nous'} },
      { path: 'nous-contacter', component: CmsComponent, data : {slug : 'nous-contacter'} },
      { path: 'acceder-aux-ressources', component: CmsComponent, data : {slug : 'acceder-aux-ressources-familles'} },
      { path: 'enedownload', component: CmsComponent, data : {slug : 'enedownload-familles'} },
      //Redirect
      { path: '**', redirectTo: '/familles' },
    ],
  },
  {
    path: '',

    children: [
      { path: '', component: HomeComponent },
      { path: 'familles', component: HomeComponent },
      { path: 'services', component: KneServicesComponent },
      { path: 'recherche', component: ListComponent },
      { path: 'recherche/:query', component: ListComponent },
      { path: 'primaire', component: ListComponent },
      { path: 'college', component: ListComponent },
      { path: 'lycee', component: ListComponent },
      { path: 'lycee-pro', component: ListComponent },
      { path: 'post-bac', component: ListComponent },
      { path: 'fle', component: ListComponent },
      { path: 'editeur/:id', component: ListComponent },
      {
        path: 'article/:slug', component: ArticleComponent
      },
      { path: 'actualites', component: ActualiteComponent },
      { path: 'actualite/:slug', component: ActualiteDetailComponent },
      { path: 'nouveautes', component: NouveauteComponent },
      { path: 'mon-panier', component: CartComponent },
      //Not Auth
      { path: 'creer-compte', component: SignInComponent, canActivate: [NotAuth] },
      { path: 'identification', component: LogInComponent, canActivate: [NotAuth] },
      //Auth
      { path: 'mon-compte', component: ProfileComponent, canActivate: [AuthGuard] },
      { path: 'mes-commandes', component: PurchasesComponent },
      { path: 'mes-ressources', component: RessourcesComponent },
      { path: 'justificatifs', component: ValidationComponent },
      { path: 'adresses', component: AddressComponent },
      { path: 'paiement', component: PaymentComponent },
      { path: 'confirmation', component: ConfirmComponent },
      //CMS
      { path: 'comment-ca-marche', component: CmsComponent, data : {slug : 'acheter-une-licence'} },
      { path: 'cgv', component: CmsComponent, data : {slug : 'cgv'} },
      { path: 'cgu', component: CmsComponent, data : {slug : 'cgu'} },
      { path: 'donnees-personnelles', component: CmsComponent, data : {slug : 'donnees-personnelles'} },
      { path: 'mentions-legales', component: CmsComponent, data : {slug : 'mentions-legales'} },
      { path: 'qui-sommes-nous', component: CmsComponent, data : {slug : 'qui-sommes-nous'} },
      { path: 'nous-contacter', component: CmsComponent, data : {slug : 'nous-contacter'} },
      { path: 'acceder-aux-ressources', component: CmsComponent, data : {slug : 'acceder-aux-ressources'} },
      { path: 'cookies', component: CmsComponent, data : {slug : 'cookies'} },
      { path: 'telechargement-lecteur-educadhoc', component: CmsComponent, data : {slug : 'telechargement-lecteur-educadhoc'} },
      { path: 'enedownload', component: CmsComponent, data : {slug : 'enedownload'} },
      //Redirect
      { path: '**', redirectTo: '' },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes
      , {
        enableTracing: false,
        useHash: false,
      } // <-- debugging purposes only
    )
  ],
  exports: [ RouterModule ],
  providers: [ AuthGuard, NotAuth ]
})
export class AppRoutingModule {}
// export const routingComponents = [
//   AppComponent,
//   HomeComponent,
//   ActualiteComponent,
//   ActualiteDetailComponent,
//   KneServicesComponent,
//   ArticleComponent,
//   ArticleResolver,
//   NouveauteComponent,
// ];


// WEBPACK FOOTER //
// ./src/app/app.routing.ts